import { useState } from 'react';
import { ArrowUpRight, KeyRound } from 'lucide-react';
import { post } from './api';
import { text, type Locale } from '../shared/content';
import { errorText } from './i18n';
const title = text(
    'A fresh start, safely.',
    '安全地重新开始。',
    '安全地重新開始。',
    'Un nuevo comienzo, seguro.',
  ),
  label = text(
    'New password · 10+ characters',
    '新密码 · 至少 10 位',
    '新密碼 · 至少 10 位',
    'Nueva contraseña · 10+ caracteres',
  ),
  save = text('Reset password', '重设密码', '重設密碼', 'Restablecer contraseña'),
  back = text('Back to sign in', '返回登录', '返回登入', 'Volver a iniciar sesión');
export default function AuthRecovery({
  token,
  locale,
  onComplete,
  onMessage,
}: {
  token: string | null;
  locale: Locale;
  onComplete: (changed: boolean) => void;
  onMessage: (s: string, error?: boolean) => void;
}) {
  const [password, setPassword] = useState(''),
    [busy, setBusy] = useState(false),
    [error, setError] = useState('');
  return (
    <div className="public-share-page">
      <a className="public-share-brand" href="/">
        AMERICAN DREAM <small>ONLINE · NEW YORK</small>
      </a>
      <section>
        <KeyRound size={31} />
        <h2>{title[locale]}</h2>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            setBusy(true);
            try {
              await post('/auth/reset-password', { token, newPassword: password });
              onComplete(true);
            } catch (e) {
              setError(errorText(locale, e));
              onMessage(errorText(locale, e), true);
            } finally {
              setBusy(false);
            }
          }}
        >
          <label>
            {label[locale]}
            <input
              type="password"
              required
              minLength={10}
              maxLength={128}
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <button className="button primary full" disabled={busy || !token}>
            {save[locale]}
            <ArrowUpRight size={15} />
          </button>
        </form>
        {error && (
          <p className="form-error" role="alert">
            {error}
          </p>
        )}
        <button className="text-button" onClick={() => onComplete(false)}>
          {back[locale]}
        </button>
      </section>
    </div>
  );
}
